/**
 * Something
 * @constructor
 */
var PD = PD || {};

PD.forms = (function(f) {
  /**
   * Form constructor. A field is given by an object of format
   * {
   *   type: <String|Function>,
   *   ...
   * }
   * @param {Array}         fields      List of fields with above format to insert
   * @param {Function}      action      Function to call when submitting
   * @param {String|Object} actionText  Text to show on submit button
   *                                    If object, contain .text and .class
   */
  function Form(fields, action, actionText, captcha){
    // TODO: multiple columns
    // TODO: actions
    
    this._captcha = {};
    this.action = action;
    this.$elm = $("<form class='form-horizontal' method='"+this.method+"' enctype='multipart/form-data'>")
      .on("submit", this._submit.bind(this) );
    
    // add every field to .fields and $elm
    this.fields = [];
    for (var i = 0; i < fields.length; i++) {
      var field = this._addField(fields[i], i);
      this.$elm.append(
        field._get$Element()
      );
      field.validate(); // so we can add mandatory-asterisk, etc.
    }

    if (captcha) {
      captcha = (typeof captcha === "object") ? captcha : {};
      captcha.active = true;
      captcha.siteKey = (/^(dev|stage|cleandev01|devcc|[a-z0-9]+\.stage)/).test(window.location.hostname)
        ? '6Le5a4siAAAAALUxr7HtfZOVfr40ndUgxY47FLrG'     // Site key for testing
        : '6Lf5ZosiAAAAACeQMl_iWTYRSSNV6q8BQwRkVKet';    // Site key for production
      captcha.cls = captcha.cls ? "g-recaptcha " + captcha.cls : "g-recaptcha";
      captcha.placement = captcha.placement ? captcha.placement : "inline";

      var captchaElm = "<div class='" + captcha.cls + "' data-size='invisible' data-sitekey='" + captcha.siteKey + "' data-badge='" + captcha.placement + "'></div>";

      // Add captcha:
      this.$elm.append(
        $(
          "<div class='form-group'>" +
            "<div class='col-sm-offset-3 col-sm-9 center-xs g-recaptcha-container'>" +
              (captcha.placement === "inline" ? captchaElm : "") +
            "</div>" +
          "</div>"
        )
      );

      if (captcha.placement !== "inline") {
        $(document.body).append(captchaElm);
      }

      this._captcha = captcha;
    }

    // add buttons
    actionText = actionText || _("Submit");
    var actionClass = "btn btn-"+(actionText.class ? actionText.class : "primary");
    actionText = actionText.text ? actionText.text : actionText;

    this.$actions = $( // these will be disabled on submit
      "<div class='form-group'>" +
        "<div class='col-sm-offset-3 col-sm-9 center-xs'>" +
          "<button type='submit' class='"+actionClass+"' data-action='submit'>"+actionText+"</button>" +
        "</div>" +
      "</div>"
    ).appendTo(this.$elm).find("button");
  }
  Form.prototype = {
    action: null,
    target: "_self",
    method: "post",

    singleSubmit: false,
    
    //twoColumn: false,
    fields: null,
    
    $elm: $(),
  };

  /**
   * Instantiates a given field, and adds it to .fields
   * @param {object} cfg  The configuration object
   * 
   * @returns {Object}  The instantiated field
   */
  Form.prototype._addField = function(cfg, index) {
    var instance,
        type = cfg.type;
    // find reference to func
    if (typeof type === "string") {
      type = PD.forms.fields._aliases[type];
    }

    // instantiate
    if (typeof type === "function") {
      instance = new type(cfg, index, this);
    } else {
      console.error("[PD.forms.Form] Unknown field: ",cfg.type);
    }

    if (typeof cfg.ref === "function") {
      cfg.ref(instance);
    }

    this.fields.push(instance);
    return instance;
  };

  /**
   * Handles submitting the form
   */
  Form.prototype._submit = function() {
    var ret = false;
    
    if (!this._isLoading) {
      if (this.validate()) {
        // Set form loading
        this.setLoading();
      
        if (typeof this.action === "function") {
          this.$elm.attr("action","#");
          ret = this.action(this.getValues());
        } else if (typeof this.action === "string") {
          this.$elm.attr("action",this.action);
          this.$elm[0].submit();
          //ret = true;
        } else {
          // TODO: throw error: Unknown action type
        }
        
        // TODO: Handle single submit option?
        if (this.singleSubmit) {
          // Form okay, cancel any further submits:
          this.$elm.off("submit").on("submit",function() {
            return false;
          });
          
          // TODO: Enable submit again?
        }
      } else {
        this._shake();
      }
    } else {
      ret = null;
    }
    
    return ret;
  };

  /**
   * Sets the forms state to loading, disabling the UI
   */
  Form.prototype.setLoading = function() {
    this._isLoading = true;
    
    // Disable form buttons:
    this.$actions.attr("disabled","disabled");
    
    // Add loading spinner:
    this.$actions.filter("button[data-action=submit]")
      .append(
        '<span data-content="loading">' +
          '&nbsp;<i class="fa fa-spinner fa-spin"></i>' +
        '</span>'
      );
    
    // TODO: Disable form fields
  };

  /**
   * Removes the loading state, enabling the UI
   */
  Form.prototype.clearLoading = function() {
    this._isLoading = false;
    
    // Enable form buttons:
    this.$actions.removeAttr("disabled");
    
    // Remove loading spinner:
    this.$actions
      .find('span[data-content=loading]').remove();
    
    // TODO: Enable form fields
  };

  /**
   * Gets every value in the form, in the format
   * {
   *   fieldName1: value1
   *   fieldName2: value2,
   *   anotherField: value
   * }
   */
  Form.prototype.getValues = function() {
    var values = {};
    
    for (var i = 0; i < this.fields.length; i++) {
      var field = this.fields[i];

      if (!field._exclude) {
        // handle multi-value fields (eg. CityField)
        if ($.isArray(field.name)) {
          var val = field.getValue();
          for (var j = 0; j < field.name.length; j++) {
            values[field.name[j]] = val[j];
          }
        } else {
          values[field.name] = field.getValue();
        }
      }
    }

    return values;
  };

  /**
   * Sets a group of values in the field.
   * Values should be in format used by .getValues
   * @param {Array|Object} values  The values to set, in the format used by .getValues
   * @param {boolean} [dontClear] If true, don't clear non-specified values
   */
  Form.prototype.setValues = function(values, dontClear) {
    var ret = false;
    
    if (typeof values === "object") {
      for (var i = 0; i < this.fields.length; i++) {
        // TODO: Check reply?
        var val,
            field = this.fields[i];
        if (dontClear && !(field.name in values)) { continue; }

        // handle multi-value fields (eg. CityField)
        if ($.isArray(field.name)) {
          val = [];
          for (var j = 0; j < field.name.length; j++) {
            val.push( values[field.name[j]] );
          }
        } else {
          val = values[field.name];
        }
        
        field.setValue(val);
      }
      ret = true;
    } else {
      // TODO: Throw error
      console.error("[PD.forms.Form] Attempted to set invalid values: ",values);
    }
    
    return ret;
  };

  /**
   * Clears every field in the form
   */
  Form.prototype.clearValues = function() {
    for (var i = 0; i < this.fields.length; i++) {
      // TODO: Check reply?
      this.fields[i].clearValue();
    }
    return true;
  };

  /**
   * Clears every feedback in the form
   */
  Form.prototype.clearFeedback = function() {
    for (var i = 0; i < this.fields.length; i++) {
      this.fields[i]._setFeedback("");
    }
    return true;
  };

  /**
   * Validates every field in the form
   */
  Form.prototype.validate = function() {
    var valid = true;
    
    for (var i = 0; i < this.fields.length; i++) {
      valid = this.fields[i].validate() && valid;
    }

    return valid;
  };

  /**
   * Fetch the captcha token and returns it in a callback function
   * 
   * @param {function} callback
   */
  Form.prototype.getCaptchaToken = function (callback) {
    var token = null;

    if (this._captcha.active) {
      grecaptcha.execute().then(function (token) {
        callback(token);
      });
    } else {
      callback(token);
    }
  };

  /**
   * Insert the form into the DOM
   */
  Form.prototype.insert = function($container, replace) {
    if (replace) {
      $($container).replaceWith(this.$elm);
    } else {
      $container.append(this.$elm);
    }

    if (this._captcha) {
      var captchaLanguage = $("html").attr("lang") || "da";
      $("head").append('<script src="https://www.google.com/recaptcha/api.js?hl=' + captchaLanguage + '" async defer></script>');
    }
  };

  /**
   * Applies the .shake class, removing it when the CSS `shake` animation has ended
   */
  Form.prototype._shake = function() {
    var elm = this.$elm[0];
    this.$elm.addClass("shake");
    // listen for animation end, then unbind and remove class
    elm.addEventListener("animationend", function listener(e){
      if (e.animationName !== "shake" || e.elapsedTime === 0) { return; }

      // remove class
      $(elm).removeClass("shake");
      // stop listening
      elm.removeEventListener("animationend", listener);
    });
  };


  f.Form = Form;
  return f;
})(PD.forms || {});

// TODO: FormWindow (should include hideOnSubmit and .hide/.show methods)
// TODO: Actions
